import "~/assessment_app/styles/main.css";

import { createApp } from "vue";
import { createPinia } from "pinia";
import * as Sentry from "@sentry/vue";
import Smartlook from "smartlook-client";

import "~/assessment_app/validations";

import App from "~/assessment_app/App.vue";
import router from "~/assessment_app/router";
import { useGlobalStore } from "~/assessment_app/stores/global";
import { useAssessmentStore } from "~/assessment_app/stores/assessment";

document.addEventListener("DOMContentLoaded", () => {
  const config = JSON.parse(document.getElementById("config").innerHTML);
  const app = createApp(App);

  Sentry.init({
    app,
    dsn: config.sentry.dsn,
    environment: config.sentry.environment,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [
      // Or omit `router` if you're not using vue-router
      Sentry.browserTracingIntegration({ router }),
    ],
    tracesSampleRate: config.sentry.tracesSampleRate,
    _experiments: { enableLogs: true },
    integrations: [
      Sentry.consoleLoggingIntegration({
        levels: ["debug", "log", "error", "warn"],
      }),
    ],
  });

  if (config.smartlookProjectKey) {
    Smartlook.init(config.smartlookProjectKey, { region: "us" });
    Smartlook.record({ forms: true, numbers: true, emails: true, ips: true });
  }

  const pinia = createPinia();

  app.use(router);
  app.use(pinia);

  const globalStore = useGlobalStore(pinia);
  const assessmentStore = useAssessmentStore(pinia);

  globalStore.$subscribe((mutation, state) => {
    console.log("globalStore mutation", mutation);
  });

  assessmentStore.$subscribe((mutation, state) => {
    console.log("assessmentStore mutation", mutation);
  });

  globalStore.config = config;

  app.mount("#app");
});
